angular.module('schoolLinqApp').directive('siteClaimSection', function () {
	return {
		scope: {
			module: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/siteClaimSection.html'),
	};
});
